import { CountyResource } from './CountyResource';

export class CityResource {
    rid: number;
    county: CountyResource;
    name: string;
}